// extracted by mini-css-extract-plugin
module.exports = {"container":"SingleReturnInfo_container__i23Gi","title":"SingleReturnInfo_title__nmL2E"};